<template>
  <div class="video-box">
    <img class="close" src="../../assets/images/close.png" alt="" @click.stop="changeShowVideo">
    <video id="my-video" class="video-js vjs-big-play-centered" controls preload="auto" data-setup="{}">
      <source src="https://wystatic.jokerhu.com/video/output.mp4" type="video/mp4">
      <p class="vjs-no-js">
        Sorry, your browser doesn't support embedded videos.
      </p>
    </video>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  export default {
    computed: {
      ...mapGetters({
        showVideo: 'getShowVideo',
      })
    },
    methods: {
      changeShowVideo() {
         this.$store.commit('mutation_showVideo', !this.showVideo)
      },
      initVideo() {
        this.$nextTick(() => {
          let myPlayer = this.$video(document.getElementById('my-video'), {
            controls: true, // 是否显示控制条
            // poster: 'xxx', // 视频封面图地址
            preload: 'auto',
            autoplay: false,
            fluid: true, // 自适应宽高
            language: 'zh-CN', // 设置语言
            muted: false, // 是否静音
            inactivityTimeout: false,
            // playbackRates: [0.5, 1, 1.5, 2, 3],// 倍速播放
            controlBar: {
              // 自定义按钮的位置
              children: [
                {name: 'playToggle'}, // 播放按钮
                {name: 'currentTimeDisplay'}, // 当前已播放时间
                {name: 'progressControl'}, // 播放进度条
                {name: 'durationDisplay'}, // 总时间
                // { // 倍数播放
                //   name: 'playbackRateMenuButton',
                //   'playbackRates': [0.5, 1, 1.5, 2, 2.5]
                // },
                {
                  name: 'volumePanel', // 音量控制
                  inline: false, // 不使用水平方式
                },
                {
                  name: "pictureInPictureToggle" //画中画播放模式
                },
                {name: 'FullscreenToggle'}, // 全屏
              ]
            },
          });
          myPlayer.src('https://wystatic.jokerhu.com/video/output.mp4'); // 重新初始化URL
          // myPlayer.load(url); //重新加载
        })
      },
    },
    mounted() {
      this.initVideo();
    }
  }
</script>

<style lang="less" scoped>
.video-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  width: 100vw;
  height: 100vh;
  background-color: #000000;
  position: fixed;
  top: 0;
  z-index: 99;
  .close {
    display: block;
    width: 24px;
    height: 24px;
    position: absolute;
    top: 20px;
    right: 20px;
  }
  .video-js {
    display: block;
    width: 100%;
    height: 300px;
    overflow: hidden;

  }
}
</style>